
import { createSlice } from "@reduxjs/toolkit";

let initiaHomeContents = {}
const homeContentsSlice = createSlice({
    name: 'homeContentsSlice',
    initialState: initiaHomeContents,
    reducers: {
        setHomeContents: (state, action) => {
            return {
                ...action.payload
            }
        },
        resetHomeContents: () => {
            return initiaHomeContents
        }
    },
});

export const { setHomeContents, resetHomeContents } = homeContentsSlice.actions;
export default homeContentsSlice.reducer;